import MentoringAvatarStub from './MentoringAvatarStub.vue';

export * from './types';
export default MentoringAvatarStub;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/index.ts